import { render } from "./TheFooter.vue?vue&type=template&id=66657702"
import script from "./TheFooter.vue?vue&type=script&lang=ts"
export * from "./TheFooter.vue?vue&type=script&lang=ts"

import "./TheFooter.vue?vue&type=style&index=0&id=66657702&lang=css"
script.render = render

export default script